import { isNil, keys, last } from 'lodash';
// Import Components
import { SegmentModal } from 'components/SegmentModal';
// Import Constants
import { CustomersTypesLabels } from 'constants/common';

const modalConfig = {
    Segment: {
        acceptTypes: ['WfSegmentId', 'WfSegmentId[]', 'WfKpiConfig'],
        render(item, handleClose) {
            return (
                <SegmentModal
                    targetObject={+CustomersTypesLabels.Customers}
                    segmentId={item?.Id}
                    segmentType={item?.Type}
                    handleClose={handleClose}
                    isVisible={true}
                />
            );
        },
    },
};

const getModalConfig = (baseTypes: string[] = []) => {
    const formsTypes = keys(modalConfig).reduce(
        (acc, item) => {
            acc = {
                ...acc,
                ...modalConfig[item].acceptTypes.reduce((types, type) => {
                    types[type] = item;
                    return types;
                }, {}),
            };
            return acc;
        },
        {} as Record<string, string>,
    );

    const matchedType = baseTypes
        .map((baseType) => last(baseType.split('.')))
        .find((baseType) => !isNil(formsTypes[baseType as keyof typeof formsTypes]));

    if (!isNil(matchedType)) {
        return modalConfig[formsTypes[matchedType]];
    }
    return {};
};

export { getModalConfig };
